// Predefined stamp emojis — fun set for teenage artists
export const STAMPS = [
  { id: 'star', emoji: '⭐', label: 'Star' },
  { id: 'heart', emoji: '❤️', label: 'Heart' },
  { id: 'fire', emoji: '🔥', label: 'Fire' },
  { id: 'sparkle', emoji: '✨', label: 'Sparkle' },
  { id: 'rainbow', emoji: '🌈', label: 'Rainbow' },
  { id: 'flower', emoji: '🌸', label: 'Flower' },
  { id: 'butterfly', emoji: '🦋', label: 'Butterfly' },
  { id: 'moon', emoji: '🌙', label: 'Moon' },
  { id: 'sun', emoji: '☀️', label: 'Sun' },
  { id: 'cloud', emoji: '☁️', label: 'Cloud' },
  { id: 'lightning', emoji: '⚡', label: 'Lightning' },
  { id: 'skull', emoji: '💀', label: 'Skull' },
  { id: 'ghost', emoji: '👻', label: 'Ghost' },
  { id: 'alien', emoji: '👽', label: 'Alien' },
  { id: 'cat', emoji: '🐱', label: 'Cat' },
  { id: 'dog', emoji: '🐶', label: 'Dog' },
  { id: 'palette', emoji: '🎨', label: 'Palette' },
  { id: 'music', emoji: '🎵', label: 'Music' },
  { id: 'gem', emoji: '💎', label: 'Gem' },
  { id: 'crown', emoji: '👑', label: 'Crown' },
  { id: 'eyes', emoji: '👀', label: 'Eyes' },
  { id: 'peace', emoji: '✌️', label: 'Peace' },
  { id: 'thumbsup', emoji: '👍', label: 'Thumbs Up' },
  { id: 'hundred', emoji: '💯', label: 'Hundred' },
];
